// views/Settings/VendorTaxSettingsPage.js
// The vendor's own VAT and EFRIS position, in the vendor Settings group. The
// component is the one the profile screens embed; nothing new.
import React from "react";
import SettingsPanel from "../../components/SettingsPanel";
import VendorTaxSettings from "../../components/VendorTaxSettings";

const VendorTaxSettingsPage = () => (
  <SettingsPanel icon="fa-landmark" title="Tax" subtitle="Your VAT registration and EFRIS enrolment" maxWidth={960}>
    <VendorTaxSettings />
  </SettingsPanel>
);

export default VendorTaxSettingsPage;
